import BasicTable from 'components/Form/Table';
import ModalCuradoria from 'components/Modal/ModalCuradoria';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ReadOne } from 'services/financing-proposals';
import { Icon, Title } from 'ui/styled';
import { exposeStrapiError } from 'utils';
import { parseCurrency } from 'utils/parsers';
import {
  EspelhoButton,
  FinancingProposalFormsWrapper,
  FinancingProposalHeader,
  FormSpacing,
} from './styled';

export default function FinancingTableCuradoria() {
  const history = useHistory();
  const { id } = useParams();
  const { filterExpression } = useContext(CoreContext);
  const [register, setRegister] = useState(null);
  const [registers, setRegisters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const init = useCallback(async () => {
    if (!id) return;
    const result = await ReadOne(id);
    if (result && !exposeStrapiError(result)) {
      // CAMPOS FIXOS DA PROPOSTA
      const reg = {
        proposta_id: result.id,
        distributor: result.distribuidor?.trade_name || '—',
        integrator: result.integrador?.nome_fantasia || '—',
        customer: result.informacoes_cliente?.nome_completo || '—',
      };
      setRegister(reg);
      setRegisters(result.propostas_banco || []);
    }
  }, [id]);

  useEffect(() => init(), [init]);

  const handleClickVoltar = () => history.goBack();

  const abrirModalCuradoria = useCallback(
    (row) => {
      const data = {
        banco: {
          id: row.id,
          nome_fantasia: row.financial,
          status: 'recusado',
          observacoes: '',
          valor: row.valor_financiamento,
          banco: { nome_fantasia: row.financial },
        },
        id: id,
        reload: init,
      };
      setModalData(data);
      setShowModal(true);
    },
    [id, init]
  );

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  // COLUNAS
  const columns = useMemo(
    () => [
      { title: 'Distribuidora', ref: 'distributor' },
      { title: 'Integrador', ref: 'integrator' },
      { title: 'Cliente', ref: 'customer' },
      { title: 'Valor.', ref: 'valor_financiamento' },
      { title: 'Banco', ref: 'financial' },
      {
        title: '',
        ref: '',
        renderCell: ({ row }) => (
          <Icon
            icon="arrow-right"
            pointer
            onClick={() => abrirModalCuradoria(row)}
            style={{ cursor: 'pointer', fontSize: '20px' }}
          />
        ),
      },
    ],
    [abrirModalCuradoria]
  );

  // LINHAS
  const rows = useMemo(() => {
    if (!register || !registers?.length) return [];
    return registers
      .filter(
        (r) =>
          ['recusado', 'em analise', 'aprovado'].includes(
            r.status?.toLowerCase()
          ) && r.curadoria?.toLowerCase() === 'sim'
      )
      .map((m) => ({
        id: m?.id,
        proposta_id: register.proposta_id,
        date: moment(m?.createdAt).format('L'),
        financial: m?.banco?.nome_fantasia,
        valor_financiamento: parseCurrency(m?.valor_financiamento),
        distributor: register.distributor,
        integrator: register.integrator,
        customer: register.customer,
      }));
  }, [registers, register]);

  return (
    <ContainerAuthenticated>
      <Title>Proposta de Financiamento</Title>
      <FinancingProposalFormsWrapper>
        <FormSpacing />
        <FinancingProposalHeader
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Title small nomargin>
            ({rows?.length || 0}) Bancos para Curadoria
          </Title>
          <EspelhoButton small onClick={handleClickVoltar}>
            Voltar
          </EspelhoButton>
        </FinancingProposalHeader>
        {rows?.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Nenhum banco para Curadoria</p>
          </div>
        ) : (
          <BasicTable columns={columns} rows={rows?.filter(filterExpression)} />
        )}
        <FormSpacing />
      </FinancingProposalFormsWrapper>
      {showModal && modalData && (
        <ModalCuradoria
          {...modalData}
          onConfirm={closeModal}
          onClose={closeModal}
        />
      )}
    </ContainerAuthenticated>
  );
}
